//Dependecies
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, CircleMarker } from "react-leaflet";
import { isMobileOnly } from 'react-device-detect';
//Components
import Drawer01 from '../components/drawers/Drawer01';
import Map01 from '../components/maps/Map01';
import Menu01 from '../components/menus/Menu01';
import Modal01 from '../components/modals/Modal01';
import Sidemenu01 from '../components/sidemenus/Sidemenu01';
//Databases
import Biz from '../../databases/biz';
import Dimensions from '../../databases/dimensions';
//Index
import BizIndex from '../../databases/bizIndex';

const MainRouter = () =>
{
  const dispatch = useDispatch();

  const [markerList01, setMarkerList01] = useState(null);
  const [markerList02, setMarkerList02] = useState(null);

  const timer = useSelector(state => state.app.timer);

  const location = useSelector(state => state.map.location);
  const center = useSelector(state => state.map.center);
  const zoom = useSelector(state => state.map.zoom);
  const layers = useSelector(state => state.map.layers); 
  const selected = useSelector(state => state.map.selected); 

  const clickMarker = useCallback((data) => 
  {
    dispatch({type: 'SET_CENTER', center : data.location});

    dispatch({type: 'SET_SELECTED', selected : data});
    dispatch({type: 'SET_LAST', last : data});

    setTimeout(() => 
    {
      dispatch({type: 'SET_TIMER', timer : true});
    }, 200);

    setTimeout(() => 
    {
      dispatch({type: 'SET_DRAWER_01', drawer01 : true});
    }, 400);
  }, [dispatch]);

  /* DIMENSIONS */
  const height = window.innerHeight;
  const width = window.innerWidth;

  /* MARKERS */
  useEffect(() => 
  {
    let markerArray01 = Object.keys(Biz).map((m1, i) => 
    {
      let info = {...Biz[m1]};
      let indexID = Object.keys(BizIndex).find(f1 => BizIndex[f1].id === info.id);
      let index = {...BizIndex[indexID]};

      if(index.exist && index.paid)
      {

        return(
          <CircleMarker
            className = 'markerShadow'
            key   = {i}
            center = {info.location}
            radius = {12}
            fill = "true"
            color = '#fff'
            fillColor = '#fc5501'
            opacity = {1.0}
            fillOpacity = {1.0}
            weight = {2}
            onClick = {() => clickMarker(info)}
          />
        );
      }
      else
      {
        return null;
      }
    });

    let markerArray02 = Object.keys(Biz).map((m1, i) => 
    {
      let info = {...Biz[m1]};
      let indexID = Object.keys(BizIndex).find(f1 => BizIndex[f1].id === info.id);
      let index = {...BizIndex[indexID]};

      if(index.exist && index.paid)
      {
        return(
          <CircleMarker
            className = 'markerShadow'
            key   = {i}
            center = {info.location}
            radius = {12}
            fill = "true"
            color = '#fff'
            fillColor = '#fc5501'
            opacity = {1.0}
            fillOpacity = {1.0}
            weight = {2}
            onClick = {() => clickMarker(info)}
          >
            <Tooltip direction = "right" offset = {[12, 0]} permanent = {true}>{`${info.info.name.toUpperCase()}`}</Tooltip>
          </CircleMarker>
        );
      }
      else
      {
        return null;
      }
    });
     
    setMarkerList01(markerArray01);
    setMarkerList02(markerArray02);
  }, [clickMarker]);

  return(
    <React.Fragment>
      <Menu01
        height        = {Math.round(Dimensions.menu * height / 100)}
        visible       = {true}
      />

      <Modal01
        height        = {Math.round(Dimensions.modal01 * height / 100)}
        width         = {Math.round(95 * width / 100)}
        visible       = {true}

        isMobile      = {isMobileOnly}
      />

      <Sidemenu01
        height        = {Math.round((Dimensions.menu) * height / 100)}
        layers        = {layers}
        visible       = {true}
      />

      {selected && timer &&
        <Drawer01
          data          = {selected}
          isMobile      = {isMobileOnly}
        />
      }

      {markerList01  &&
        <Map01
          location      = {location}
          height        = {window.innerHeight}
          center        = {center}
          zoom          = {zoom}
          paddingTop    = {0}
          paddingBottom = {0}          
          layers        = {layers}

          list01        = {markerList01}
          list02        = {markerList02}
        />
      }
    </React.Fragment>
  );
}

export default MainRouter;